import { atomFamily } from "jotai-family";
import { selectAtom } from "jotai/utils";
import type { Answer } from "../../../components/Questionnaire/Section/Question/types";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

export const questionnaireAnswerAtom = atomFamily((questionName: string) =>
  selectAtom(
    questionnaireReducerAtom,
    state => state.answers[questionName] as Answer | undefined,
  ),
);
